export default function getSavedJobsList() {
  return fetch('https://my-json-server.typicode.com/ashishbhaleraobits/jin/SavedJobs')
    .then(data =>data.json())
}
